// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5897) return "static/chunks/f8025e75-5dfeebcff5ae1fb0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1761":"d0deef33","7776":"477d4af2"}[chunkId] || chunkId) + "." + {"1761":"1fe3afdf5d5ad41b","3345":"bf220df040fafa15","5539":"1eb98563fc4ff581","7041":"714819f0dd305a8b","7072":"e8164303d04128b0","7316":"9404b8bc7c3e9b2e","7776":"bace0a87464dd2ea","9750":"8bb012885f2ddeaf"}[chunkId] + ".js";
};